import React from 'react';

// tslint:disable max-line-length
const CStartGiftTranscriptDemo: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. You can tell a gift that somebody has thought about, compared to one where they panicked, or didn’t bother, or ran out of ideas, can’t you? A good one sort of tells you about what they think of you, what you mean to them.  Today, you’re going make a gift for someone special. They might be next to you right now. They might be on the other side of the world. Close your eyes and try to get a picture of them in your head.</p>
  </>
);

export {
  CStartGiftTranscriptDemo,
};
